module.exports = __webpack_public_path__ + "static/contact-a17165fdb242f6435ede1a46a7f2b4ec.svg";